(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/helpers/utils.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/helpers/utils.js');
"use strict";


(function (Backbone, _, svs) {
  'use strict';

  svs.grassroots.helpers.getOmsKey = function () {
    var omskey;
    switch (svs.core.data.capabilities.channel) {
      case 'ios-hybrid-mobile':
      case 'android-hybrid-mobile':
        omskey = '36';
        break;
      case 'ios-hybrid-tablet':
      case 'android-hybrid-tablet':
        omskey = '37';
        break;
      case 'web-mobile':
        omskey = '31';
        break;
      case 'web-tablet':
        omskey = '34';
        break;
      case 'web-desktop':
        omskey = '10';
        break;
      default:
        omskey = '31';
    }
    return omskey;
  };
  svs.grassroots.helpers.populateYearlyStatistics = function (receivers, callback, error) {
    var receiversId = receivers.map(function (receiver) {
      return receiver.id;
    }).join(',');
    var options = {
      method: 'GET',
      path: "/player/1/sponsorship/receiverinfo?receivers=".concat(receiversId, "&includeStatisticsInReply=true")
    };
    svs.core.jupiter.call(options, function (result) {
      result.receivers.forEach(function (receiverInfo) {
        receivers.forEach(function (receiver) {
          if (receiverInfo.id === receiver.id && receiverInfo.yearlystatistics !== null) {
            var yearlystatistics = [];
            receiverInfo.yearlystatistics.sort(function (a, b) {
              return b.year - a.year;
            }).forEach(function (yearStat) {
              var totalPayment = null;
              yearStat.monthlystatistics.forEach(function (monthStat) {
                if (monthStat.payment !== null) {
                  totalPayment += monthStat.payment.totalamount;
                }
              });
              if (totalPayment !== null) {
                yearlystatistics.push({
                  year: yearStat.year,
                  totalPayment: totalPayment
                });
              }
            });
            receiver.yearlystatistics = yearlystatistics;
          }
        });
      });
      callback(receivers);
    }, function (_xhr, _textStatus, errorThrown) {
      error(errorThrown);
    });
  };
})(Backbone, _, svs);

 })(window);